export default [

     {
          path: '/notification',
          name: 'notification',
          component: () => import("@/views/Page/notification/notification.vue"),
           meta: {
               title: 'notification',
          },
     }
];